import { Alert, Platform, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { SubHeading, Body } from '@/components/ui/Text';
import { useTheme } from '@/theme';
import { openSupportMailbox, SUPPORT_EMAIL } from '@/utils/supportContact';
import { logAnalyticsEvent } from '@/services/analyticsLogger';
import { openUserInitiatedRating } from '@/services/ratingPrompt';

export function HelpAndFeedbackCard() {
  const theme = useTheme();

  const handleSupportPress = (kind: 'bug' | 'feedback' | 'feature') => {
    void logAnalyticsEvent('feedback_entry_tapped', {
      source: 'settings',
      kind,
    });
    void openSupportMailbox(kind);
  };

  const handleRatePress = async () => {
    const opened = await openUserInitiatedRating('settings');
    if (!opened && Platform.OS !== 'web') {
      Alert.alert('Rate Tripvio', 'We could not open the app store right now. Please try again later.');
    } else if (!opened) {
      Alert.alert('Rate Tripvio', 'App store ratings are available in the installed mobile app.');
    }
  };

  return (
    <Card variant="outlined">
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: theme.spacing(1.5), marginBottom: theme.spacing(1) }}>
        <Ionicons name="chatbubble-ellipses-outline" size={24} color={theme.colors.primary} />
        <SubHeading>Help and feedback</SubHeading>
      </View>
      <Body color={theme.colors.textSecondary} style={{ marginBottom: theme.spacing(1.5) }}>
        Report bugs, send feedback, or request features. Messages go to {SUPPORT_EMAIL}.
      </Body>
      <View style={{ gap: theme.spacing(1) }}>
        <Button
          label="Rate Tripvio"
          variant="secondary"
          onPress={() => void handleRatePress()}
          icon={<Ionicons name="star-outline" size={18} color={theme.colors.text} />}
          accessibilityHint="Opens the app store rating flow when available"
        />
        <Button
          label="Report a bug"
          variant="secondary"
          onPress={() => handleSupportPress('bug')}
          icon={<Ionicons name="bug-outline" size={18} color={theme.colors.text} />}
          accessibilityHint="Opens your email app to report a bug to Tripvio support"
        />
        <Button
          label="Send feedback"
          variant="secondary"
          onPress={() => handleSupportPress('feedback')}
          icon={<Ionicons name="heart-outline" size={18} color={theme.colors.text} />}
          accessibilityHint="Opens your email app to send general feedback to Tripvio support"
        />
        <Button
          label="Request a feature"
          variant="secondary"
          onPress={() => handleSupportPress('feature')}
          icon={<Ionicons name="bulb-outline" size={18} color={theme.colors.text} />}
          accessibilityHint="Opens your email app to suggest a new feature to Tripvio support"
        />
      </View>
    </Card>
  );
}
